import { FloatingTextCSSStyle, FloatingTextCSSStyleImpl } from '../floatingtextcss';
import { Fonts } from '../../../../utils/resources/fonts';
import { Colors } from '../../../../utils/resources/colors';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';


export interface MsisdnFloatingTextCSSStyle extends FloatingTextCSSStyle
{
    getCountryCodeCSSStyle(): object;
    getFloatingErrorTextCSSStyle(isFloatingLabel: boolean): object;
    getMSISDNTextCSSStyle(language:any): object;
    getErrorTextDivCSSStyle(): object ;
}

export class MsisdnFloatingTextCSSStyleImpl extends FloatingTextCSSStyleImpl implements MsisdnFloatingTextCSSStyle
{
    
    getCountryCodeCSSStyle(): object {
       return {
        fontSize: this.getResources().getFont(Fonts.h9),
        color: this.getResources().getColor(Colors.color_4),
        height: "30px",
        position: "absolute",
        textDecoration: "none",
        border: 0,
        marginTop: "4px",
        fontWeight: 500,
        letterSpacing: 0,
        lineHeight: "20px",
        outline: "none",
        fontFamily: this.getResources().getFontFamily()
       };
    }

    getTextCSSStyle(isFloatingLabel: boolean): object 
    {
        console.log("isFloatingLabel: " + isFloatingLabel);
        if(isFloatingLabel)
        {
            return {
                fontSize:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH? this.getResources().getFont(Fonts.h9):"16px",
                color: this.getResources().getColor(Colors.color_4),
                fontFamily: this.getResources().getFontFamily(),
                height: "30px",
                bottom: "3px",
                width: "100%",
                textDecoration: "none",
                borderTop: 0,
                paddingLeft: "45px",
                paddingRight: "0px",
                borderRight:0,
                fontWeight: 500,
                letterSpacing: 0,
                lineHeight: "20px",
                borderBottom: "1px solid " + this.getResources().getColor(Colors.color_39),
                borderLeft:0,
                outline: "none"
            };
        }
        else
        {
            return {
                fontSize:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH? this.getResources().getFont(Fonts.h9):"16px",
                fontFamily:this.getResources().getFontFamily(),
                color: this.getResources().getColor(Colors.color_4),
                height: "30px",
                bottom: "3px",
                width: "100%",
                paddingLeft: "0px",
                paddingRight: "0px",
                textDecoration: "none",
                borderTop: 0,
                borderRight:0,
                fontWeight: 500,
                letterSpacing: 0,
                lineHeight: "20px",
                borderBottom: "1px solid " + this.getResources().getColor(Colors.color_39),
                borderLeft:0,
                outline: "none"
            };
        }
    }

    getErrorTextDivCSSStyle(): object 
    {
        return {
            width:"50%",
           display: "flex",
        
        };
    }
    getMSISDNTextCSSStyle(language:any): object {
        return {
            color: this.getResources().getColor(Colors.color_7),
            // fontSize: this.getResources().getFont(Fonts.h5),
            margin:'3px 0px 0px auto',
            height:'auto',
            fontFamily:this.getResources().getFontFamily()

        };
    } 
    getFloatingErrorTextCSSStyle(isFloatingLabel: boolean): object 
    {
        if(isFloatingLabel)
        {
            return {
                fontSize: this.getResources().getFont(Fonts.h9),
                color: this.getResources().getColor(Colors.color_4),
                height: "30px",
                bottom: "3px",
                textDecoration: "none",
                borderTop: 0,
                borderRight:0,
                fontWeight: 500,
                width: "100%",
                paddingLeft:"50px",
                paddingRight: "0px",
                borderBottom: "2px solid " + this.getResources().getColor(Colors.color_11),
                borderLeft:0,
                outline: "none",
                fontFamily: this.getResources().getFontFamily()

            };
        }
        else
        {
            return {
                fontSize: this.getResources().getFont(Fonts.h9),
                color: this.getResources().getColor(Colors.color_4),
                height: "30px",
                bottom: "3px",
                textDecoration: "none",
                borderTop: 0,
                width: "100%",
                borderRight:0,
                fontWeight: 500,
                paddingLeft: "0px",
                paddingRight: "0px",
                borderBottom: "2px solid " + this.getResources().getColor(Colors.color_11),
                borderLeft:0,
                outline: "none",
                fontFamily:this.getResources().getFontFamily()

            };
        }
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/floatingtext/msisdnfloatingtext/msisdnfloatingtextcss.tsx